import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import contactForm from "../views/contactForm.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "contactForm",
    component: contactForm,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
